import React from "react";
import { SpecsheetSVG } from "./specsheetSVG.jsx";
import styled from "styled-components";
import { connect } from "react-redux";
import { specsheetParser } from "../specsheet/specsheetParser";

const PanelSpecsheet = styled.div`
  font-size: 10px;
  position: relative;
  width: 60%;
  max-width: 810px;
  margin: 0 auto;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: -0.5em -5em;
  -moz-transition: top 0.3s ease;
  -webkit-transition: top 0.3s ease;
  -o-transition: top 0.3s ease;
  transition: top 0.3s ease;
  top: 0em;
  container: svg-container / inline-size;

  @media only screen and (min-width: 992px) and (orientation: landscape) {
    flex: 1 1 0;
    min-width: 0;
    min-height: 0;
    height: 100%;
    width: 100%;
    max-width: none;
    display: flex;
    align-items: center;
    justify-content: center;

    > svg.specsheet {
      width: 100%;
      height: 100%;
      max-height: 100%;
    }
  }

  @media only screen and (min-width: 768px) and (orientation: portrait) {
    width: 95%;
    max-width: none;
  }

  @media only screen and (min-width: 768px) and (max-width: 1439px) and (orientation: landscape) {
    width: 60%;
    max-width: none;
  }

  @media (max-width: 767px) {
    width: 100%;
    max-width: none;
  }
`;


const SpecsheetImageRedux = ({
  formValues,
}) => {
  let f1_insertless = false;
  if (
    (formValues?.f1_grip_type || "").toLowerCase() === "no inserts" ||
    formValues?.f1_grip_type === ""
  ) {
    f1_insertless = true;
  }

  let f2_insertless = false;
  if (
    (formValues?.f2_grip_type || "").toLowerCase() === "no inserts" ||
    formValues?.f2_grip_type === ""
  ) {
    f2_insertless = true;
  }

  let specsheetSVGRef = React.createRef();
  return (
    <PanelSpecsheet>
      <SpecsheetSVG ref={specsheetSVGRef} />
    </PanelSpecsheet>
  );
};

export const SpecsheetImage = connect((state) => ({
  formValues: specsheetParser(state.settings.appSettings)(
    state.specsheet.currentSpecSheet
  ),
}))(SpecsheetImageRedux);
